module.exports = __webpack_public_path__ + "img/login-5defebrero.21316ba0.svg";